<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <div>
              <b-row>
                <b-col sm="12">
                  <i class="fa fa-bars"></i> {{ $t('str.search-history') }}
                </b-col>
              </b-row>
            </div>
            <div>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="4">Keyword</b-col>
                    <b-col sm="4">Date Range</b-col>
                    <b-col sm="4">Country</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                      <b-form-input id="keyword" class="form-control" type="text" name="keyword"
                        :placeholder="$t('str.search')" v-model="keyword" @keyup.enter="getAllSearchHistory()">
                      </b-form-input>
                    </b-col>
                    <b-col sm="4">
                      <flat-pickr :config="dateConfig" v-model="dateRange" id="date_range" class="form-control"
                        name="date_range"></flat-pickr>
                    </b-col>
                    <b-col sm="4">
                      <b-form-select id="country" name="country" :plain="true" v-model="country" style="height:100%;">
                        <option value="">All</option>
                        <option v-for="(c, index) in countryListSelect" :value="c.value" :key="index">{{ c.text }}
                        </option>
                      </b-form-select>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="4">Result Status</b-col>
                    <b-col sm="4">Category</b-col>
                    <b-col sm="4"></b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                      <b-form-select id="found" name="found" :plain="true" v-model="found" style="height:100%;">
                        <option value="">All</option>
                        <option value="found">Found only</option>
                        <option value="notfound">Not found only</option>
                      </b-form-select>
                    </b-col>
                    <b-col sm="4">
                      <b-form-select id="category" name="category" :plain="true" v-model="category"
                        style="height:100%;">
                        <option value="">All</option>
                        <option value="4w">4W</option>
                        <option value="2w">2W</option>
                      </b-form-select>
                    </b-col>
                    <b-col sm="4">
                      <b-button type="button" variant="secondary" @click="resetFilter()" class="mr-1">{{
                          $t('str.reset-filter')
                      }}</b-button>
                      <b-button type="submit" variant="primary" @click="getAllSearchHistory()" class="mr-1">{{ $t('str.search') }}
                      </b-button>
                      <b-button type="submit" variant="secondary" class="px-4" @click="exportFile()"
                        :disabled="submittedExport"><i v-if="submittedExport"
                        class="fa fa-spinner fa-spin"></i>{{ $t('str.export') }}</b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
          <p :class="{ 'text-center': true, 'd-none': items.length }" class="">{{ $t('str.no-data') }}</p>
          <b-table :class="{ 'd-none': !items.length }" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template slot="created_at" slot-scope="data">
              {{ data.item.created_at | moment('from', 'now') }}
            </template>
          </b-table>
          <nav :class="{ 'd-none': !items.length }">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged" prev-text="Prev"
              next-text="Next" />
          </nav>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import Pagination from '@/views/component/Pagination'
import Buttons from '@/views/component/Buttons'

export default {
  name: 'SearchHistory',
  components: {
    'paging': Pagination,
    'buttons': Buttons
  },
  props: {
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data() {
    return {
      items: [],
      countryListSelect: [],
      fields: [
        { key: 'no', label: 'No.' },
        { key: 'value', label: 'Keyword', sortable: true },
        { key: 'count', label: 'Search Count', sortable: true },
        { key: 'created_at', label: 'Last Searched', sortable: true },
        { key: 'vehicle_category', label: 'Category', sortable: true }
      ],
      keyword: '',
      found: '',
      country: '',
      count: 'desc',
      dateRange: (moment().subtract(1, "months").format('YYYY-MM-DD')) + ' - ' + (moment().format('YYYY-MM-DD')),
      dateConfig: {
        locale: { rangeSeparator: ' - ' },
        mode: "range",
        altInput: true,
        altFormat: "d M Y",
        dateFormat: "Y-m-d",
        defaultDate: [(moment().subtract(1, "months").format('YYYY-MM-DD')), (moment().format('YYYY-MM-DD'))]
      },
      category: '',
      submittedExport: false,
      currentPage: 1,
      totalPage: 0
    }
  },
  methods: {
    async getAllCountry() {
      this.$auth.checkSession()
      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Search/History/Country`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        for (var i = 0; i < cData.length; i++) {
          this.countryListSelect.push({ 'value': cData[i].code, 'text': cData[i].name })
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getAllSearchHistory(page) {
      this.$auth.checkSession()

      let dates = this.dateRange.split(' - ')

      let trail = `?limit=${this.$helper.envi.VUE_APP_PAGING_LIMIT}`
      if (page) trail = `${trail}&page=${page}`
      if (this.keyword != '') trail = `${trail}&keyword=${this.keyword}`
      if (this.found != '') trail = `${trail}&found=${this.found}`
      if (this.dateRange != '') trail = `${trail}&start_date=${dates[0]}&end_date=${dates[1]}`
      if (this.count != '') trail = `${trail}&count=${this.count}`
      if (this.country != '') trail = `${trail}&country=${this.country}`
      if (this.category != '') trail = `${trail}&category=${this.category}`

      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Search/History${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.items = getData.data.data
        this.currentPage = getData.data.meta.page
        this.totalPage = getData.data.meta.pageCount
      } catch (e) {
        console.log(e.response)
      }
    },
    async exportFile() {
      this.exportFileSuccess = ''
      this.exportFileError = ''
      this.$auth.checkSession()

      let dates = this.dateRange.split(' - ')

      let trail = `?`
      if (this.keyword != '') trail = `${trail}&keyword=${this.keyword}`
      if (this.found != '') trail = `${trail}&found=${this.found}`
      if (this.dateRange != '') trail = `${trail}&start_date=${dates[0]}&end_date=${dates[1]}`
      if (this.count != '') trail = `${trail}&count=${this.count}`
      if (this.country != '') trail = `${trail}&country=${this.country}`

      let url = `${this.$helper.envi.VUE_APP_API_URL}/Export/SearchHistory` + trail

      try {
        this.submittedExport = true
        let file = await axios.get(url, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        if (file.data) {
          window.open(this.$helper.envi.VUE_APP_API_URL + '/' + file.data)
        }

        let delUrl = this.$helper.envi.VUE_APP_API_URL + '/Export/DownloadFile/SearchHistory'
        let delAuth = this.$auth.session.get().passport
        let timer = setInterval(async function () {
          if (open.closed) {
            clearInterval(timer)
            await axios.get(delUrl, {
              headers: { 'Authorization': `Bearer ${delAuth}` }
            })
          }
        }, 1000)
      } catch (e) { console.log(e) }
      this.submittedExport = false
    },
    resetFilter() {
      this.keyword = ''
      this.found = ''
      this.country = ''
      this.dateRange = (moment().subtract(1, "months").format('YYYY-MM-DD')) + ' - ' + (moment().format('YYYY-MM-DD')),
        this.getAllCountry()
      this.getAllSearchHistory()
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.getAllSearchHistory(pageNum)
    }
  },
  created() {
    this.getAllCountry()
    this.getAllSearchHistory()
  }
}
</script>